import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

import MapLocation from './MapLocation';
import ModalContent from './ModalContent';

const StepDeploymentLocation = (props) => {
  const { deploymentSite, setDeploymentSite } = props;

  const [latInput, setLatInput] = useState(
    deploymentSite?.latitude != null ? String(deploymentSite.latitude) : '',
  );
  const [lonInput, setLonInput] = useState(
    deploymentSite?.longitude != null ? String(deploymentSite.longitude) : '',
  );

  // Keep inputs in sync when the map updates the pin (desktop drag/click)
  useEffect(() => {
    if (deploymentSite?.latitude != null && parseFloat(latInput) !== deploymentSite.latitude) {
      setLatInput(String(deploymentSite.latitude));
    }
  }, [deploymentSite?.latitude]);

  useEffect(() => {
    if (deploymentSite?.longitude != null && parseFloat(lonInput) !== deploymentSite.longitude) {
      setLonInput(String(deploymentSite.longitude));
    }
  }, [deploymentSite?.longitude]);

  const setLocation = (location) => {
    setDeploymentSite({
      ...deploymentSite,
      latitude: location.latitude,
      longitude: location.longitude,
    });
  };

  const handleLatChange = (e) => {
    const raw = e.target.value;
    setLatInput(raw);
    const parsed = parseFloat(raw);
    if (!Number.isNaN(parsed) && !raw.endsWith('.')) {
      setDeploymentSite({ ...deploymentSite, latitude: parsed });
    }
  };

  const handleLonChange = (e) => {
    const raw = e.target.value;
    setLonInput(raw);
    const parsed = parseFloat(raw);
    if (!Number.isNaN(parsed) && !raw.endsWith('.')) {
      setDeploymentSite({ ...deploymentSite, longitude: parsed });
    }
  };

  return (
    <div className="deployment-location">
      <ModalContent
        heading="Confirm Deployment Location"
        body="The map shows the platform&apos;s last known location."
      />
      {/* TODO: update ModalContent to support multiple paragraphs */}
      <p>
        If it looks correct, continue as is. Otherwise, drag the pin or
        enter coordinates manually below. If no location is available,
        please set it manually.
      </p>
      <MapLocation
        marker={deploymentSite}
        setMarkerLocation={setLocation}
      />
      <div
        style={{
          marginTop: 15,
          display: 'flex',
          gap: '1rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            color: 'white',
            flex: 1,
          }}
        >
          <label
            style={{ marginBottom: '0.25rem', fontSize: '0.9rem' }}
          >
            Latitude °N
          </label>
          <Input
            value={latInput}
            onChange={handleLatChange}
            style={{
              backgroundColor: '#03304B',
              color: 'white',
              border: '1px solid #8197A5',
              borderRadius: '6px',
              padding: '0.5rem 0.75rem',
              fontSize: '1rem',
            }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            color: 'white',
            flex: 1,
          }}
        >
          <label
            style={{ marginBottom: '0.25rem', fontSize: '0.9rem' }}
          >
            Longitude °W
          </label>
          <Input
            value={lonInput}
            onChange={handleLonChange}
            style={{
              backgroundColor: '#03304B',
              color: 'white',
              border: '1px solid #8197A5',
              borderRadius: '6px',
              padding: '0.5rem 0.75rem',
              fontSize: '1rem',
            }}
          />
        </div>
      </div>
    </div>
  );
};

StepDeploymentLocation.propTypes = {
  deploymentSite: PropTypes.object,
  setDeploymentSite: PropTypes.func,
};

StepDeploymentLocation.defaultProps = {
  deploymentSite: {},
  setDeploymentSite: () => {},
};

export default StepDeploymentLocation;
